import React from "react";
import { Link } from "react-router-dom";

export default function Hero({ content = {} }) {
  const title = content.hero_title || "The complete gift voucher platform";
  const subtitle = content.hero_subtitle || "Grow your revenue and streamline operations with the hospitality industry’s favourite gift voucher platform.";
  const cta = content.hero_cta || "Book your demo";
  const ctaLink = content.hero_cta_link || "/signup";
  const external = /^https?:\/\//i.test(ctaLink);
  return (
    <section className="gp-hero-gradient relative overflow-hidden pt-[76px]">
      <div className="max-w-[1240px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center min-h-[620px] py-16">
          {/* Left */}
          <div className="relative z-10">
            <h1 className="text-white font-bold text-[2.9rem] sm:text-[3.5rem] leading-[1.05] tracking-tight">
              {title}
            </h1>
            <p className="text-[#c9d2e0] text-[1.15rem] leading-relaxed mt-6 max-w-[480px]">
              {subtitle}
            </p>
            {external ? (
              <a href={ctaLink} data-testid="hero-cta" className="gp-btn-teal inline-block rounded-full px-8 py-3.5 text-[1.05rem] font-medium mt-9">{cta}</a>
            ) : (
              <Link to={ctaLink} data-testid="hero-cta" className="gp-btn-teal inline-block rounded-full px-8 py-3.5 text-[1.05rem] font-medium mt-9">{cta}</Link>
            )}
          </div>

          {/* Right - layered event photos */}
          <div className="relative h-[420px] hidden lg:block">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative w-[520px] h-[400px]">
                <img
                  src={content.hero_image_envelope || "https://images.unsplash.com/photo-1518189160488-85a12d5c98a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"}
                  alt="Live event crowd"
                  className="absolute left-0 top-8 w-[380px] h-[280px] object-cover rounded-3xl shadow-2xl animate-[float_6s_ease-in-out_infinite]"
                />
                <img
                  src={content.hero_image_phone || "https://images.unsplash.com/photo-1535119512-9e6a24a532c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600"}
                  alt="Concert stage lights"
                  className="absolute right-2 top-0 w-[220px] h-[300px] object-cover rounded-3xl shadow-2xl ring-4 ring-white/10 animate-[float_6s_ease-in-out_infinite_reverse]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-14px); }
        }
      `}</style>
    </section>
  );
}
